export function filter(response) {
    return { type: 'FILTER', payload: response };
}
